"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORGANISATION_STATUS = void 0;
var ORGANISATION_STATUS = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
  DRAFT: 'DRAFT',
  CANCELLED: 'CANCELLED',
  PAUSED: 'PAUSED'
};
exports.ORGANISATION_STATUS = ORGANISATION_STATUS;